import { VALIDATION_MESSAGES, REGEX_PATTERNS } from 'eebac/constants';


const FIELDS = {
    subject: {
        type: "input",
        label: "Subject",
        isRequired: true,
        xs:12,
        lg:9,
        sm:12,
        md:12,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            length: {
                minimum: 2, maximum: 255
            }
        }
    },
};

export default FIELDS;